import { combineReducers } from "redux";
import menuReducer from "./menuReducer";
import isResultReducer from "./isResultReducer";
import roleReducer from "./roleReducer";
import menuRoleReducer from "./menuRoleReducer";
//IndexImportHygen
const allMenuRoleReducer = combineReducers({
    isResultReducer,
    menuReducer,
    roleReducer,
    menuRoleReducer
    //IndexUsingHygen
})

export default allMenuRoleReducer;